import { useTexture } from '@react-three/drei'

export default function Soap(props)
{
    // Web Technologies, Database, and Creative Skills with professional textures
    const htmlTexture = useTexture('./Textures/html-skill.jpg')
    const cssTexture = useTexture('./Textures/css-skill.jpg')
    const dbmsTexture = useTexture('./Textures/dbms-skill.jpg')
    const videoEditTexture = useTexture('./Textures/video-skill.jpg')

    return <>
        {/* CSS Soap */}
        <mesh
            geometry={props.nodes.CssSoap.geometry}
            position={[0, 1, 0]}
        >
            <meshBasicMaterial map={cssTexture} map-flipY={false} />
        </mesh>

        {/* HTML Soap */}
        <mesh
            geometry={props.nodes.HtmlSoap.geometry}
            position={[0, 1, 0]}
        >
            <meshBasicMaterial map={htmlTexture} map-flipY={false} />
        </mesh>

        {/* Video Editing Soap */}
        <mesh
            geometry={props.nodes.JavascriptSoap.geometry}
            position={[0, 1, 0]}
        >
            <meshBasicMaterial map={videoEditTexture} map-flipY={false} />
        </mesh>

        {/* DBMS Soap */}
        <mesh
            geometry={props.nodes.PythonSoap.geometry}
            position={[0, 1, 0]}
        >
            <meshBasicMaterial map={dbmsTexture} map-flipY={false} />
        </mesh>
    </>
}